module.exports = __webpack_public_path__ + "6c4a0dbc/img/link-icon.fa09ed66.svg";